export const UPDATE_CARGO_DETAILS = "UPDATE_CARGO_DETAILS";
export const ADD_CONTAINER_DETAILS = "ADD_CONTAINER_DETAILS";
export const DELETE_CONTAINER_DETAILS = "DELETE_CONTAINER_DETAILS";
export const ADD_PACKAGE_DETAILS = "ADD_PACKAGE_DETAILS";
export const DELETE_PACKAGE_DETAILS = "DELETE_PACKAGE_DETAILS";
export const ADD_BULK_DETAILS = "ADD_BULK_DETAILS";
export const DELETE_BULK_DETAILS = "DELETE_BULK_DETAILS";
export const UPDATE_QUOTATION_CARGO_DETAILS = "UPDATE_QUOTATION_CARGO_DETAILS"